import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Spinner } from "@fluentui/react-components";
import { Dismiss24Filled } from "@fluentui/react-icons";
import React, { useRef } from "react";
import { getDwsimProStartupActionsClient, getLicensingClient, getUsersClient } from "../../services/dashboard.service";
import { processServerError } from "../../utils/helpers/error.helper";
import { CreateStartupActionPostModel, DwsimProAction, GetLicenseInfoPostModel, UserResponseModel } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";
import { S365Button } from "../s365-button/s365-button.component";
import { useDwsimProLicense } from "../../contexts/DwsimProLicenseContext";
import moment from "moment";
import { settings } from "../../App";

type DwsimProLicenseCheckerModalProps = {
    isOpened?: boolean;
    fileUniqueIdentifier?: string;
    filename?: string;
    isStripeRedirect?: boolean;
    onClose: () => void;
}

export const DwsimProLicenseCheckerModal: React.FC<DwsimProLicenseCheckerModalProps> = (props) => {

    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [openingMessage, setOpeningMessage] = React.useState<string>();
    const [showInfoMessage, setShowInfoMessage] = React.useState<boolean>(false);
    const licenseInterval = React.useRef<number>();

    const { isValidLicense, reloadLicense, activeSubscription } = useDwsimProLicense();
    React.useEffect(() => {
        onInit();
        return () => {
            if (!!licenseInterval.current) {
                window.clearInterval(licenseInterval.current);
            }
        }
    }, []);

    React.useEffect(() => {
        setOpen(!!props.isOpened);

    }, [props.isOpened]);


    const onInit = async () => {
        try {
            await reloadLicense();
            console.log("activeSubscription", activeSubscription);
            setIsLoading(true);

        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting DWSIM Pro license status.");
            onModalClose();
        } finally {
            setIsLoading(false);
        }
    }
    const updateLicenseInfo = async () => {
        try {
            await reloadLicense();
        } catch (error) {
            processServerError(error, undefined, "An error occurred while reloading license info.");
            if (!!licenseInterval?.current)
                window.clearInterval(licenseInterval.current);
        }
    }

    React.useEffect(() => {
        if (!!props.isStripeRedirect) {
            setOpeningMessage("Assigning DWSIM Pro license...");
            licenseInterval.current = window.setInterval(() => {

                updateLicenseInfo();
            }, 3000);
        }

    }, [props.isStripeRedirect]);

    React.useEffect(() => {
        if (isValidLicense) {
            if (!!licenseInterval?.current)
                window.clearInterval(licenseInterval.current);

            RedirectToDwsimPro();
        }
    }, [isValidLicense]);

    const RedirectToDwsimPro = async () => {
        setOpeningMessage("Opening DWSIM Pro...");
        if (!!props.fileUniqueIdentifier) {
            await SaveDwsimProStartupAction();
        }
        setShowInfoMessage(true);
    }
    const SaveDwsimProStartupAction = async () => {
        try {
            const client = getDwsimProStartupActionsClient();
            const postModel = new CreateStartupActionPostModel({
                actions: [new DwsimProAction({ action: "load-flowsheet", data: { "fileUniqueIdentifier": props.fileUniqueIdentifier, "filename": props.filename } })]
            });
            await client.addStartupAction(postModel);


        } catch (error) {
            processServerError(error, undefined, "An error occurred while saving DWSIM Pro startup action.");
        }
    }


    const onModalClose = () => {
        setOpen(false);
        if (props.onClose)
            props.onClose();
    }

    const onContinueClick = (url: string) => {
        window.open(url, '_blank');
    };



    return (<Dialog open={open} onOpenChange={(event, data) => {

        setOpen(data.open);
        if (!data.open) {
            onModalClose();
        }

    }}>
        <DialogSurface>

            <DialogBody>
                <DialogTitle action={<Button appearance="transparent" onClick={onModalClose} icon={<Dismiss24Filled />} />}>
                </DialogTitle>
                <DialogContent>
                    {isLoading && <div style={{ display: "flex", justifyContent: "center", gap: "5px" }} ><Spinner size="tiny" /> Checking for DWSIM Pro license...</div>}
                    {!isLoading && !isValidLicense && !openingMessage && !activeSubscription && <p style={{ textAlign: "center" }}>
                        You don't have an active DWSIM Pro subscription.<br /> Please purchase a subscription to use DWSIM Pro.</p>}
                    {!isLoading && !isValidLicense && !openingMessage && !!activeSubscription && <div>
                        <h2 style={{ textAlign: "center" }}>Your subscription allowance has been exhausted!</h2>
                        <p style={{ textAlign: "center" }}>
                            You've used all <b>{activeSubscription.allowedTokens} hours</b> included in your current subscription for this billing cycle.<br />
                            Your next billing cycle begins on <b>{moment(activeSubscription.validToUtc).format("DD.MM.YYYY")}</b>, when your usage hours will reset.
                        </p>
                        <p style={{ textAlign: "center" }}>Upgrade your subscription now to continue to use DWSIM Pro.</p>
                    </div>}
                    {!!openingMessage && !showInfoMessage && <div style={{ display: "flex", justifyContent: "center", gap: "5px" }} ><Spinner size="tiny" /> {openingMessage}</div>}
                    {!!showInfoMessage && !!isValidLicense && <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "10px" }}>
                        <p><h2>You are all set!</h2></p>
                        <S365Button onClick={(ev) => { ev.preventDefault(); onContinueClick(settings.dwsimProRemoteAppUrl); }}>Continue to DWSIM Pro</S365Button>
                    </div>}
                </DialogContent>
            </DialogBody>

        </DialogSurface>
    </Dialog>);
}

